import _ from 'lodash';
import { Record } from 'immutable';

const PhotoHashDefaults = {
  url: null,
  child_resolutions: []
};

class PhotoHash extends Record(PhotoHashDefaults) {
  constructor(values) {
    // Sort child_resolutions
    if(values && values.child_resolutions) {
      values.child_resolutions = _.sortBy(values.child_resolutions, (cr) => {
        cr.url = useSecureUrl(cr.url);
        return cr.width;
      });
    }

    if(values.url) {
      values.url = useSecureUrl(values.url);
    }

    super(values);
  }

  getClosestToTarget(targetWidth) {
    let selected = _.find(this.child_resolutions, (cr) => {return cr.width >= targetWidth;});
    return selected ? selected.url : this.url;
  }

  getChildByWidth(width) {
    return _.find(this.child_resolutions, (cr) => {return cr.width >= width;});
  }
}

export default PhotoHash;

function useSecureUrl(url) {
  return url.replace(/^(http:)/, 'https:');
}



// WEBPACK FOOTER //
// banquet/models/PhotoHash.js